module.exports = __webpack_public_path__ + "static/media/forge_logo.e0e8ac05.png";